import React, { useEffect, useState } from 'react';
import { DateRangePicker, isInclusivelyBeforeDay, DayPickerRangeController } from 'react-dates';
import moment from 'moment';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import {
  makeStyles, useMediaQuery, useTheme, Box, Tooltip,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import CloseIcon from '@material-ui/icons/Close';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { withTranslation, i18n } from 'config/i18n';
import SearchTimeStyle from 'views/motorcycle_rental/components/widget/SearchTimeStyle';
import TooltipStyle from 'views/motorcycle_rental/components/widget/TooltipStyle';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import RenderDatePickerValue from 'views/motorcycle_rental/components/widget/RenderDatePickerValue';

const useStyles = makeStyles((theme) => ({
  ...SearchTimeStyle(theme),
  ...TooltipStyle(theme),
  tipBox: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    padding: theme.spacing(2),
    cursor: 'not-allowed',
  },
  tipCalendar: {
    fill: theme.palette.grey[300],
    width: theme.spacing(2),
    marginRight: theme.spacing(1),
  },
  tipText: {
    color: theme.palette.grey[300],
  },
}));

const SearchTime = ({ t, data }) => {
  const {
    startDate,
    endDate,
    disabled,
    minimumDate,
    showCalendar,
    withoutInput,
    onChange,
    showClearDates = true,
  } = data;

  // Note we we use DayPickerRangeController the focusedInput prop may be null,
  // but if this is the case, dates are not selectable.
  // As a result, in the example wrapper, we always force focusedInput to be truthy in the onFocusChange method.
  // So we add a truthy value in case we use DayPickerRangeController
  const START_DATE = withoutInput ? 'startDate' : null;
  const classes = useStyles();

  const theme = useTheme();
  const mediumUp = useMediaQuery(theme.breakpoints.up('md'));

  const [focusedInput, setFocusedInput] = useState(START_DATE);

  const props = {
    startDate: startDate ? moment(startDate) : null,
    endDate: endDate ? moment(endDate) : null,
    onDatesChange: onChange,
    onFocusChange: (focusInput) => {
      setFocusedInput(focusInput || START_DATE);
    },
    navPrev: <ChevronLeftIcon />,
    navNext: <ChevronRightIcon />,
    numberOfMonths: mediumUp ? 2 : 1,
    daySize: 40,
    minimumNights: 1,
    disabled,
    hideKeyboardShortcutsPanel: true,
    keepOpenOnDateSelect: false,
    isOutsideRange: (day) => isInclusivelyBeforeDay(moment(day), moment(minimumDate).subtract(1, 'days')),
    focusedInput,
  };

  const rangePickerProps = {
    startDateId: 'widget-start-date',
    endDateId: 'widget-end-date',
    displayFormat: 'MMM DD',
    customCloseIcon: <CloseIcon />,
    showClearDates,
    reopenPickerOnClearDates: true,
    readOnly: true,
  };

  const rangePickerControllerProps = {
    transitionDuration: 0,
  };
  useEffect(()=>{
    moment.locale(i18n.language)
  } , [])
  return (
    <>
      {showCalendar ? (
        <div
          className={`${classes.calendarRoot} ${startDate !== '' ? 'filled' : ''}
          `}
        >
          {!withoutInput && (
            <RenderDatePickerValue
              startDate={startDate}
              endDate={endDate}
              label={t('fe_es_geo_widget:time.label')}
              // disabled={disabled}
              filled={startDate !== ''}
            />
          )}
          {withoutInput ? (
            <DayPickerRangeController {...rangePickerControllerProps} {...props} />
          ) : (
            <DateRangePicker {...props} {...rangePickerProps} />
          )}
        </div>
      ) : (
        <Tooltip
          arrow
          classes={{
            arrow: classes.tooltipArrowOverride,
            tooltip: classes.tooltipOverride,
          }}
          enterTouchDelay={10}
          title={(
            <>
              <ErrorOutlineIcon />
              {t('fe_es_geo_widget:time.enter_place_first')}
            </>
          )}
        >
          <Box className={classes.tipBox}>
            <DateRangeIcon className={classes.tipCalendar} />
            <span className={classes.tipText}>{t('fe_es_geo_widget:time.label')}</span>
          </Box>
        </Tooltip>
      )}
    </>
  );
};
export default withTranslation(['fe_es_geo_widget'])(SearchTime);
